import { render, staticRenderFns } from "./ManutencaoModal.vue?vue&type=template&id=6c3065ba"
import script from "./ManutencaoModal.vue?vue&type=script&lang=js"
export * from "./ManutencaoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports